import Model, { attr, belongsTo, hasMany } from "@ember-data/model";
import type MedicationSpecialty from "parog-web/models/medication-specialty";
import type MedicationTherapeuticalGroup from "./medication-therapeutical-group";

export default class MedicationMolecule extends Model {
  @attr("string") declare atc: string;
  @attr("boolean") declare isGroupLeader: boolean;
  @attr("string") declare label: string;
  @hasMany("medication-specialty", {
    async: false,
    inverse: "medicationMolecule"
  })
  declare medicationSpecialties: MedicationSpecialty[];
  @belongsTo("medication-therapeutical-group", {
    async: false,
    inverse: "medicationMolecules"
  })
  declare medicationTherapeuticalGroup: MedicationTherapeuticalGroup;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "medication-molecule": MedicationMolecule;
  }
}
